import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"inner-banner\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"banner-content text-center\"><h1>Job Details</h1><span></span></div></div></div></div></div>", 1)
const _hoisted_2 = { class: "job-details-pages pt-120 mb-120" }
const _hoisted_3 = {
  key: 0,
  class: "container"
}
const _hoisted_4 = { class: "row g-lg-4 gy-5" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "my-profile-inner" }
const _hoisted_7 = { class: "form-wrapper mb-60" }
const _hoisted_8 = { class: "profile-form" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-inner mb-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Upload your resume*", -1)
const _hoisted_13 = { class: "input-area" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-inner mb-25" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Your Current Designation", -1)
const _hoisted_18 = { class: "input-area" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-inner mb-25" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "Your Exprience", -1)
const _hoisted_23 = { class: "input-area" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-inner mb-25" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "Expected Salary", -1)
const _hoisted_28 = { class: "input-area" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "form-inner" }
const _hoisted_32 = { class: "col-lg-4" }
const _hoisted_33 = { class: "job-details-sidebar mb-120" }
const _hoisted_34 = { class: "job-summary-area mb-50" }
const _hoisted_35 = { class: "logo" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "company-details" }
const _hoisted_38 = { class: "name-location" }
const _hoisted_39 = { href: "#" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "job-summary-title" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Job Summary:")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Location:", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Category:", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Job Type:", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Salary:", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Job Posted:", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Expiration:", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Vacancy:", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Experiences:", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Education:", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Gender:", -1)
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"view-job-btn mb-30\"><a href=\"job-listing1.html\"><img src=\"assets/images/icon/company-2.svg\" alt=\"\">View All Jobs In This Company</a></div><div class=\"job-share-area mb-50\"><h6>Job Link Share:</h6><ul><li><a href=\"#\"><i class=\"bx bx-link\"></i></a></li><li><a href=\"https://www.facebook.com/\"><i class=\"bx bxl-facebook\"></i></a></li><li><a href=\"https://twitter.com/\"><i class=\"bx bxl-twitter\"></i></a></li><li><a href=\"https://www.linkedin.com/\"><i class=\"bx bxl-linkedin\"></i></a></li><li><a href=\"https://www.instagram.com/\"><i class=\"bx bxl-instagram-alt\"></i></a></li></ul></div>", 2)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "location-area" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Get Location:"),
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3649.564763018799!2d90.36349791490355!3d23.834071191491947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c14c8682a473%3A0xa6c74743d52adb88!2sEgens%20Lab!5e0!3m2!1sen!2sbd!4v1674212581590!5m2!1sen!2sbd",
    style: {"border":"0"},
    allowfullscreen: "",
    loading: "lazy",
    referrerpolicy: "no-referrer-when-downgrade"
  })
], -1)
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-lg-12" }
const _hoisted_56 = { class: "related-jobs" }
const _hoisted_57 = /*#__PURE__*/_createStaticVNode("<div class=\"section-title mb-40\"><h3>Related Jobs:</h3><div class=\"swiper-btn1 d-flex align-items-center\"><div class=\"left-btn prev-4\"><img src=\"assets/images/icon/explore-elliose.svg\" alt=\"\"></div><div class=\"right-btn next-4\"><img src=\"assets/images/icon/explore-elliose.svg\" alt=\"\"></div></div></div>", 1)
const _hoisted_58 = { class: "swiper related-job-slider" }
const _hoisted_59 = { class: "swiper-wrapper" }
const _hoisted_60 = { class: "feature-card" }
const _hoisted_61 = { class: "company-area" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/images/bg/company-logo/company-06.png",
    alt: ""
  })
], -1)
const _hoisted_63 = { class: "company-details" }
const _hoisted_64 = { class: "name-location" }
const _hoisted_65 = { href: "job-details.html" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "bookmark" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bookmark" })
], -1)
const _hoisted_67 = { class: "job-discription" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/arrow2.svg",
  alt: ""
}, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Salary:", -1)
const _hoisted_70 = { class: "time" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/arrow2.svg",
  alt: ""
}, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Vacancy:", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/arrow2.svg",
  alt: ""
}, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Deadline:", -1)
const _hoisted_75 = { class: "job-type-apply" }
const _hoisted_76 = { class: "apply-btn" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/images/icon/apply-ellipse.svg",
    alt: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.current_job)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("form", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _hoisted_14,
                              _createElementVNode("input", {
                                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
                                type: "file",
                                name: "cv"
                              }, null, 32)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.application.designation) = $event)),
                                placeholder: "What is your current designation"
                              }, null, 512), [
                                [_vModelText, _ctx.application.designation]
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, [
                              _hoisted_24,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.application.experience) = $event)),
                                placeholder: "How many years of experince do you have ?"
                              }, null, 512), [
                                [_vModelText, _ctx.application.experience]
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("div", _hoisted_28, [
                              _hoisted_29,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.application.salary) = $event)),
                                placeholder: "What is your expected salary ?"
                              }, null, 512), [
                                [_vModelText, _ctx.application.salary]
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("button", {
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyForPosition && _ctx.applyForPosition(...args))),
                              class: "primry-btn-2 lg-btn w-unset",
                              type: "button"
                            }, "Submit Application")
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("img", {
                        width: "200",
                        src: _ctx.current_job.company_logo,
                        alt: ""
                      }, null, 8, _hoisted_36)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("h5", null, [
                          _createElementVNode("a", _hoisted_39, _toDisplayString(_ctx.current_job.job_title), 1)
                        ]),
                        _createElementVNode("p", null, _toDisplayString(_ctx.current_job.working_mode), 1)
                      ])
                    ]),
                    _hoisted_40,
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_41,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.location), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_42,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.category), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_43,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.job_type), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_44,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.salary_range), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_45,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.posted_on), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_46,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.expiration), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_47,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.vacancy) + " Person.", 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_48,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.exprience) + " Years.", 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_49,
                          _createTextVNode(_toDisplayString(_ctx.current_job.qualification), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_50,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.gender), 1)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_51,
                  _hoisted_53
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: job.id,
                          class: "swiper-slide"
                        }, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("h5", null, [
                                    _createElementVNode("a", _hoisted_65, _toDisplayString(job.job_title), 1)
                                  ]),
                                  _createElementVNode("p", null, _toDisplayString(job.working_mode), 1)
                                ]),
                                _hoisted_66
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _hoisted_68,
                                  _createElementVNode("p", null, [
                                    _hoisted_69,
                                    _createTextVNode(" " + _toDisplayString(job.salary_range) + " / ", 1),
                                    _createElementVNode("span", _hoisted_70, _toDisplayString(job.payment_mode), 1)
                                  ])
                                ]),
                                _createElementVNode("li", null, [
                                  _hoisted_71,
                                  _createElementVNode("p", null, [
                                    _hoisted_72,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(job.vacancy) + " Person (" + _toDisplayString(job.gender) + ")", 1)
                                  ])
                                ]),
                                _createElementVNode("li", null, [
                                  _hoisted_73,
                                  _createElementVNode("p", null, [
                                    _hoisted_74,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(job.expiration), 1)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", _hoisted_76, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'job-details', query: {job_id: job.id} }
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_77,
                                    _createTextVNode("Apply Now")
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}